import React from "react";

const Field = React.forwardRef(({
  label,
  name,
  type = "text",
  value,
  onChange,
  error,
  hint,
  as = "input",
  children,
  className = "",
  inputClassName = "",
  ...rest
}, ref) => {
  const id = rest.id || name;
  const baseCls =
    as === "select" ? "field__select" :
    as === "textarea" ? "field__textarea" :
    "field__input";
  const inputCls = `${baseCls}${inputClassName ? " " + inputClassName : ""}`;

  const valueProp = value !== undefined ? { value } : {};
  const changeProp = onChange !== undefined ? { onChange } : {};

  return (
    <label className={`field${className ? " " + className : ""}`} htmlFor={id}>
      {label ? <span className="field__label">{label}</span> : null}
      {as === "select" ? (
        <select id={id} name={name} ref={ref} {...valueProp} {...changeProp} className={inputCls} {...rest}>
          {children}
        </select>
      ) : as === "textarea" ? (
        <textarea id={id} name={name} ref={ref} {...valueProp} {...changeProp} className={inputCls} {...rest} />
      ) : (
        <input id={id} name={name} type={type} ref={ref} {...valueProp} {...changeProp} className={inputCls} {...rest} />
      )}
      {error ? <span className="field__error">{error}</span> : hint ? <span className="field__hint">{hint}</span> : null}
    </label>
  );
});

Field.displayName = "Field";

export default Field;
